import React, { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { getStorage, ref, getDownloadURL, listAll } from "firebase/storage";
import { db } from '../services/firebase';
import LoadingSpinner from './LoadingSpinner';
import { ReactComponent as ClientesIcon } from '../assets/icons/ClientesIcon.svg';
import { ReactComponent as PhoneIcon } from '../assets/icons/PhoneIcon.svg';
import { ReactComponent as BirthIcon } from '../assets/icons/BirthIcon.svg';
import { ReactComponent as MailIcon } from '../assets/icons/MailIcon.svg';
import { ReactComponent as LocationIcon } from '../assets/icons/LocationIcon.svg';
import { ReactComponent as ContractIcon } from '../assets/icons/ContractIcon.svg';
import { ReactComponent as SalaryIcon } from '../assets/icons/SalaryIcon.svg';
import { ReactComponent as PdfIcon } from '../assets/icons/PdfIcon.svg';
const Perfil = ({ onLogout }) => {
const [userData, setUserData] = useState(null);
const [loading, setLoading] = useState(true);
const [leyes, setLeyes] = useState([]);
const [companyDocs, setCompanyDocs] = useState([]);
const [contrato, setContrato] = useState(null);
const [recibos, setRecibos] = useState([]);
const auth = getAuth();
useEffect(() => {
const fetchUserData = async () => {
const user = auth.currentUser;
if (user) {
const userDocRef = doc(db, "usuarios", user.uid);
const userDoc = await getDoc(userDocRef);
if (userDoc.exists()) {
setUserData(userDoc.data());
}
const storage = getStorage();
const leyesRef = ref(storage, "leyes");
const leyesList = await listAll(leyesRef);
let docsGenerales = await Promise.all(
leyesList.items.map(item => getDownloadURL(item).then(url => ({
name: item.name,
url
})))
);
const contratoRef = ref(storage, `empleados/${user.uid}/contrato/contrato_laboral.pdf`);
try {
const contratoUrl = await getDownloadURL(contratoRef);
docsGenerales.unshift({ name: "contrato_laboral.pdf", url: contratoUrl });
setContrato(contratoUrl);
} catch (err) {
console.log("No se encontró contrato", err);
}
setLeyes(docsGenerales);
let nuevosDocs = [];

// 1. OBTENER Y AGREGAR LOS MANDAMIENTOS (PRIMERO)
const xmandamientosRef = ref(storage, "empleados/xmandamientos.pdf");
try {
    const xmandamientosUrl = await getDownloadURL(xmandamientosRef);
    nuevosDocs.push({ name: "xmandamientos.pdf", url: xmandamientosUrl });
} catch (err) {
    console.log("No se encontró xmandamientos.pdf", err);
}

// 2. OBTENER Y AGREGAR NORULES (SEGUNDO)
const norulesRef = ref(storage, "empleados/norules.pdf");
try {
    const norulesUrl = await getDownloadURL(norulesRef);
    nuevosDocs.push({ name: "norules.pdf", url: norulesUrl });
} catch (err) {
    console.log("No se encontró norules.pdf", err);
}

// 3. OBTENER Y AGREGAR LIDERAR (ÚLTIMO)
const liderarRef = ref(storage, "empleados/liderar.pdf");
try {
    const liderarUrl = await getDownloadURL(liderarRef);
    nuevosDocs.push({ name: "liderar.pdf", url: liderarUrl });
} catch (err) {
    console.log("No se encontró liderar.pdf", err);
}

setCompanyDocs(nuevosDocs); 
const recibosRef = ref(storage, `empleados/${user.uid}/recibos`);
const recibosList = await listAll(recibosRef);
const recibosUrls = await Promise.all(
recibosList.items.map(item => getDownloadURL(item).then(url => ({
name: item.name,
url
})))
);
recibosUrls.sort((a, b) => b.name.localeCompare(a.name));
setRecibos(recibosUrls);
}
setLoading(false);
};
fetchUserData();
}, [auth]);
const fileNamesMap = {
'contrato_laboral.pdf': 'Contrato Laboral',
'ley_contrato_trabajo.pdf': 'Ley de Contrato de Trabajo',
'ley_firma_digital.pdf': 'Ley de Firma Digital',
'xmandamientos.pdf': 'Los Diez Mandamientos del Fracaso Empresarial', 
'norules.pdf': 'Guía para fallar a medida que la empresa crece',
'liderar.pdf': 'Liderar es una elección',
};
if (loading) {
return <LoadingSpinner />;
}
if (!userData) {
return <div>No se encontró el perfil del usuario.</div>;
}
const {
nombre,
apellido,
cuil,
fecha_alta,
fecha_nacimiento,
email,
telefono,
calle,
altura,
piso,
unidad,
codigoPostal,
ciudad,
pais,
responsabilidades
} = userData;
// Armo la dirección solo con los campos presentes (sin comas sueltas).
const direccionLinea1 = [[calle, altura].filter(Boolean).join(' '), piso, unidad, codigoPostal].filter(Boolean).join(', ');
const direccionLinea2 = [ciudad, pais].filter(Boolean).join(', ');
const tieneDireccion = Boolean(direccionLinea1 || direccionLinea2);
return (
<div className="Trazabilidad" style={{ overflow: 'hidden' }}>
<header className="trazabilidad-header">
<div className="header-content" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
<h1>Mi perfil</h1>
<div style={{ padding: '20px', textAlign: 'center' }}>
<button onClick={onLogout} className='logout-btn'>
Cerrar Sesión
</button>
</div>
</div>
</header>
<div className="profile-main-grid">
<div className="profile-column profile-data-column">
<h3 className="profile-column-title">mis Datos</h3>
<div style={{ display: 'flex', flexDirection: 'column' }}>
<p className="profile-name"><strong>{nombre} {apellido}</strong></p>
<p className="profile-cuil">CUIL {cuil}</p>
</div>
<div className="profile-data-box">
<p className="profile-data-label"><strong>Fecha de alta</strong></p>
<div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
<ClientesIcon className="menu-icon" style={{ width: '10px', fill: '#2c2c2c', margin: '0' }} />
<p className="profile-data-value">{fecha_alta}</p>
</div>
</div>
{fecha_nacimiento && (
<div className="profile-data-box">
<p className="profile-data-label"><strong>Fecha de nacimiento</strong></p>
<div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
<BirthIcon className="menu-icon" style={{ width: '10px', fill: '#2c2c2c', margin: '0' }} />
<p className="profile-data-value">{fecha_nacimiento}</p>
</div>
</div>
)}
<div className="profile-data-box">
<p className="profile-data-label"><strong>Datos de contacto</strong></p>
<div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
<MailIcon className="menu-icon" style={{ width: '10px', fill: '#2c2c2c', margin: '0' }} />
<p className="profile-data-value">{email}</p>
</div>
{telefono && (
<div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
<PhoneIcon className="menu-icon" style={{ width: '10px', fill: '#2c2c2c', margin: '0' }} />
<p className="profile-data-value">{telefono}</p>
</div>
)}
{tieneDireccion && (
<div style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'start' }}>
<LocationIcon className="menu-icon" style={{ width: '9px', fill: '#2c2c2c', margin: '8px 0 auto' }} />
<p className="profile-data-value">{direccionLinea1}{direccionLinea1 && direccionLinea2 && <br></br>}{direccionLinea2}</p>
</div>
)}          </div>
</div>
{}
<div className="profile-column profile-responsibility-column">
<h3 className="profile-column-title">mi órbita</h3>
<ul className="responsibility-list">
{responsabilidades && responsabilidades.map((resp, index) => (
<li key={index} className="responsibility-list-item">{resp}</li>
))}
{}
<div className="profile-column profile-company-docs-column">
<h3 className="profile-column-title">Lectura obligatoria</h3>
<ul className='profile-contract-list'>
{companyDocs.map((doc, index) => {
const displayName = fileNamesMap[doc.name] || doc.name.replace(".pdf", "").replaceAll("_", " ");
return (
<li key={index} style={{ display: 'flex', flexDirection: 'row', alignItems:'center' }}>
<PdfIcon className="menu-icon" style={{ height: '20px', fill: '#2c2c2c', margin: '0', marginBottom:'7px' }} />
<a href={doc.url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
{displayName}
</a>
</li>
);
})}
</ul>
</div>
</ul>
</div>
{}
<div className="profile-column profile-relationship-column">
<h3 className="profile-column-title">mi Relación con la Empresa</h3>
<ul className='profile-contract-list'>
{leyes.map((doc, index) => {
const displayName = fileNamesMap[doc.name] || doc.name.replace(".pdf", "").replaceAll("_", " ");
return (
<li key={index} style={{ display: 'flex', flexDirection: 'row' }}>
<ContractIcon className="menu-icon" style={{ height: '20px', fill: '#2c2c2c', margin: '0' }} />
<a href={doc.url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
{displayName}
</a>
</li>
);
})}
</ul>
</div>
{}
<div className="profile-column profile-payslip-column" style={{ overflow: 'hidden' }}>
<h3 className="profile-column-title">mis recibos de Sueldo</h3>
<ul className='profile-contract-list' style={{ gap: '20px', paddingBottom: '100px', overflow: 'auto' }}>
{recibos.map((recibo, index) => {
const rawName = recibo.name.replace(".pdf", "");
const [year, month] = rawName.split("-");
const formattedName = `${month}/${year}`;
return (
<li key={index}>
<SalaryIcon className="menu-icon" style={{ height: '20px', fill: '#2c2c2c', margin: '0' }} />
<a href={recibo.url} target="_blank" rel="noopener noreferrer">
{formattedName}
</a>
</li>
);
})}
</ul>
</div>
</div>
</div>
);
};
export default Perfil;